// extracted by mini-css-extract-plugin
module.exports = {"pt-link-form":"pt-link-form-e675b836599b722ed6b01f245c560be7"};